<div class="d-flex justify-flex-end">
   <div class="dropdown">
      <button class="dropbtn">
         <i class="fa fa-download"></i> {{ 'general.export_data' | translate }}
      </button>
      <div class="dropdown-content">
         <a (click)="exportToExcel()">{{ 'general.export_as_excel' | translate }} (.xlsx)</a>
         <a (click)="exportToPDF()">{{ 'general.export_as_pdf' | translate }}</a>
         <a (click)="exportToCSV()">{{ 'general.export_as_csv' | translate }}</a>
      </div>
   </div>
</div>
<br>
<div #contentToCapture class="documents-2 shadow white-bg">
   <div *ngIf="
         !(
            this.totalSubjects == 0 &&
            subjectName == undefined &&
            facultyId == '-1' &&
            departmentId == '-1' &&
            professor == '-1'
         )
      " class="filter-bar">
      <div class="filter-controls">
         <h4 class="filter-title">{{ 'general.subjects' | translate }}</h4>

         <div class="filter-right-section">
            <div class="filter-group">
               <label for="professor">{{ 'app.filter_by_educator' | translate }}</label>
               <select id="professor" class="filter-select" [(ngModel)]="professor" (change)="filterByProfessor()">
                  <option value="-1" selected>{{ 'general.all' | translate }}</option>
                  <option *ngFor="let professor of this.professors" value="{{ professor.id }}">
                     {{ professor.name }}
                  </option>
               </select>
            </div>

            <div class="filter-group">
               <label for="subjectName">{{ 'placeholders.search_by_name' | translate }}</label>
               <div class="input-with-icon">
                  <img src="assets/images/icons/search.png" alt="search" />
                  <input id="subjectName" type="text" class="filter-input" [(ngModel)]="subjectName"
                     (ngModelChange)="titleFilter()" />
               </div>
            </div>

            <div class="filter-group">
               <label>&nbsp;</label>
               <button class="reset-btn" (click)="resetFilter()" aria-label="Reset filters">
                  <div class="reset-icon-wrapper">
                     <img src="assets/images/icons/refresh.png" alt="Reset" />
                  </div>
               </button>
            </div>
         </div>
      </div>
   </div>


   <ng-template #assignmentsTemplate let-row>
      <span (click)="filterAssignment(row.subject)" class="blueText underline bold clickable">
         {{ row.assignments }}
      </span>
   </ng-template>

   <ng-template #submissionsTemplate let-row>
      <span (click)="filterSubmissions(row.subjectId)" class="blueText underline bold clickable">
         {{ row.submissions }}
      </span>
   </ng-template>

   <app-table tabindex="0" [columns]="columns"
      [paginatedData]="tableRows | paginate : { itemsPerPage: 5, currentPage: page, totalItems: totalSubjects }"
      [customTemplates]="{ assignmentsTemplate: assignmentsTemplate, submissionsTemplate: submissionsTemplate }"
      [hasDot]="false" [riskString]="' '" [decimalPlaces]="0">
   </app-table>
   <div class="zeroState" *ngIf="
         this.totalSubjects == 0 &&
         (subjectName != undefined ||
            facultyId != '-1' ||
            departmentId != '-1' ||
            professor != '-1')
      ">
      {{ 'new_entries.no_subjects_found' | translate }}
   </div>
   <pagination-controls *ngIf="this.totalSubjects != 0" class="num" (pageChange)="changePage($event)" responsive="true"
      previousLabel="" nextLabel=""></pagination-controls>

   <div class="zero-state" *ngIf="
         this.totalSubjects == 0 &&
         subjectName == undefined &&
         facultyId == '-1' &&
         departmentId == '-1' &&
         professor == '-1'
      ">
      <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
      <h5 class="bold" style="z-index: 1;">{{ 'app.there_are_no_subjects_registered_in_your_instutition' | translate }}.
         <a routerLink="/administrator/register-module/course-register" routerLinkAction="active">{{
            'general.click_here' | translate }}</a>
         to begin registering your first subject.
      </h5>
   </div>
</div>